
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { EMPTY, forkJoin, Observable, switchMap } from 'rxjs';
import { PageTitleService } from '../services/page-title.service';

export const RouteTitelResolver: ResolveFn<Observable<any>> = (route, state) => {
  const pageTitleService = inject(PageTitleService);
  return pageTitleService.getPageTitle(route.data['pageName']);

}




